import { createSlice } from "@reduxjs/toolkit";
// redux
import { batch } from "src/redux/store";
// utils
import axios, { API_ENDPOINTS } from "src/utils/axios";

// ----------------------------------------------------------------------

const initialState = {
    isLoading: false,
    error: null,
    //
    keysList: [],
    registerClientKeys: null,
    maxAppKeyNumber: null
};

const slice = createSlice({
    name: "apiKeys",
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // STOP LOADING
        stopLoading(state) {
            state.isLoading = false;
        },


        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        clearError(state) {
            state.error = null;
        },

        // GET NOTIFICATION LIST
        getKeysListSuccess(state, action) {
            state.isLoading = false;
            state.keysList = action.payload;
        },
        registerKeySuccess(state, action) {
            state.isLoading = false;
            state.registerClientKeys = action.payload;
        },
        getAppKeyLimitSuccess(state, action) {
            state.maxAppKeyNumber = action.payload;
        }
    }
});


// Reducer
export default slice.reducer;

// Actions
export const { clearError } = slice.actions;


// ----------------------------------------------------------------------

export function getApiKeysList() {
    return async (dispatch) => {
        try {
            dispatch(slice.actions.startLoading());

            const response = await axios.post(API_ENDPOINTS.api.keysList, {});

            const { status, data } = response;

            if (status === 200 && data?.code === "ok") {
                dispatch(slice.actions.getKeysListSuccess(data?.data ?? []));
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        } finally {
            dispatch(slice.actions.stopLoading());
        }
    };
}


// ----------------------------------------------------------------------

export function deleteApiKeys(id) {
    return async (dispatch) => {
        try {
            const response = await axios.post(API_ENDPOINTS.api.deleteKey, { id });

            const { status, data } = response;

            if (status === 200 && data?.code === "ok") {
                dispatch(getApiKeysList());
                return true
            }
            return false
        } catch (e) {
            dispatch(slice.actions.hasError(e));
            return e
        }
    };
}

// ----------------------------------------------------------------------

export function getAppKeyLimit() {
    return async (dispatch) => {
        try {
            const response = await axios.post(API_ENDPOINTS.api.queryAppKeyLimit, {});
            const { status, data } = response;
            if (status === 200 && data?.code === "ok") {
                dispatch(slice.actions.getAppKeyLimitSuccess(data?.data?.max_app_key_number ?? null));
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

// ----------------------------------------------------------------------

export function registerApiKey(test_model) {
    return (dispatch) => batch(async () => {
        try {
            const response = await axios.post(API_ENDPOINTS.api.registerKey, { test_model});


            const { status, data } = response || {};

            if (status === 200 && data?.code === "ok") {
                dispatch(slice.actions.registerKeySuccess(data?.data ?? []));

                dispatch(getApiKeysList());
                return  data?.data ?? {}
            }
            return false;
        } catch (e) {
            dispatch(slice.actions.hasError(e));
            return  e
        }
    });
}
